import { GradientTokens } from '../theme/index.types';
import useTheme from './useTheme';
import { parseCssGradientToSvg } from '../common/Gradient/Gradient.utils';
import { useMemo } from 'react';

const useSvgGradient = (gradientToken: GradientTokens) => {
  const theme = useTheme();
  const cssGradient = theme.color[gradientToken];

  return useMemo(() => parseCssGradientToSvg(cssGradient), [cssGradient]);
};

export default useSvgGradient;
